<template>
    <!-- <gmap-autocomplete v-if="this.search"> </gmap-autocomplete> -->
    <gmap-map
    :center="this.$store.state.maps.center_map"
    :zoom="18"
    :map-type-id="this.map_type"
    ref="map"
    >
        <gmap-marker
            :key="index"
            v-for="(m, index) in this.$store.state.maps.markers"
            :position="m.position"
            :draggable="true"
            @dragend="updateLocation"
        ></gmap-marker>
    </gmap-map>
</template>

<script>
    /* eslint-disable */
    let context;
    export default{
        name:"py-maps",

        data(){
            return {
                
            }
        },

        methods:{

            requestCurrentLocation(){
                navigator.permissions.query({
                    name: 'geolocation'
                }).then(function(result) {
                    if (result.state == 'granted') {
                        navigator.geolocation.getCurrentPosition((location)=>{
                            let cent_obj={
                                lat:location.coords.latitude,
                                lng:location.coords.longitude
                            };
                            context.setCenterMap(cent_obj);
                            context.setMarkers();[{position:{lat:location.coords.latitude,lng:location.coords.longitude}}];
                        });
                    } else if (result.state == 'prompt') {
                    } else if (result.state == 'denied') {
                        console.log(result)
                        // context.requestCurrentLocation();
                    }
                    result.onchange = function() {
                        report(result.state);
                    }
                });
            },

            updateLocation(location){                
                let new_loc = {lat:location.latLng.lat(),lng:location.latLng.lng()};
                let geocoder = new google.maps.Geocoder;
                let address = geocoder.geocode({location:new_loc},function(results, status) {
                    if (status === 'OK') {
                        new_loc=results[0];
                        context.$emit("marker_move",new_loc);
                    } else {
                        context.$notify({
                            group:"error",
                            title:"Error Notification",
                            text:"Geocoder failed due to: " + status
                        })
                    }
                });
            
            }
        },

        props:[
            'center_map',
            'markers',
            'map_type',
            'current_location',
        ],

        async mounted(){
            context=this;
            if(context.current_location){
                context.requestCurrentLocation();
            }else{
                context.$store.dispatch("SET_CENTER_MAP",context.center_map);
                context.$store.dispatch("SET_MARKERS",context.markers);
            }
        }
    }
</script>